<template>
    <v-container>
        <v-row justify="center">
            <v-col md=8 class="text-center">
                <v-card>
                    <v-container fluid>
                        <v-row>
                            <v-col class="text-center display-3 mb-5">
                                Edit Car
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col md=4 class="title">
                                <v-text-field v-model="car.name" label="Car Name"></v-text-field>
                                <v-text-field v-model="car.make" label="Make"></v-text-field>
                                <v-text-field v-model="car.model" label="Model"></v-text-field>
                                <v-text-field v-model="car.year" label="Year" type="number"></v-text-field>
                                <v-text-field v-model="car.vin" label="VIN"></v-text-field>
                                <v-text-field v-model="car.mileage" label="Mileage" type="number" min="0"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col md=4>
                                <v-btn block dark color="blue" @click="submit" :loading="loading">
                                    Update
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    props: ["carId"],
    data() {
        return {
            loading: false,
        }
    },
    computed: {
        car() {
            return this.$store.getters.getSpecificCar(this.carId);
        }
    },
    methods: {
        submit() {
            console.log('Submitting');
            
        }
    }
}
</script>